import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.d7c_1 = prereleaseMode;
        this.e7c_1 = auth0ClientId;
        this.f7c_1 = auth0Domain;
        this.g7c_1 = basename;
        this.h7c_1 = expressEnv;
        this.i7c_1 = webpackPublicPath;
        this.j7c_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.d7c_1 + ', auth0ClientId=' + this.e7c_1 + ', auth0Domain=' + this.f7c_1 + ', basename=' + this.g7c_1 + ', expressEnv=' + this.h7c_1 + ', webpackPublicPath=' + this.i7c_1 + ', websocketHost=' + this.j7c_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.d7c_1);
        result = imul(result, 31) + getStringHashCode(this.e7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j7c_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.d7c_1 === other.d7c_1))
          return false;
        if (!(this.e7c_1 === other.e7c_1))
          return false;
        if (!(this.f7c_1 === other.f7c_1))
          return false;
        if (!(this.g7c_1 === other.g7c_1))
          return false;
        if (!(this.h7c_1 === other.h7c_1))
          return false;
        if (!(this.i7c_1 === other.i7c_1))
          return false;
        if (!(this.j7c_1 === other.j7c_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
